const authPathPrefixes = ['/login', '/signup', '/forgot-password', '/reset-password', '/auth'];
const defaultLandingPaths = new Set(['/dashboard', '/']);

function isAuthPath(pathname: string): boolean {
  return authPathPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function buildLoginRedirect(pathname: string, search: string): string {
  let target = '/login';
  if (!isAuthPath(pathname) && !defaultLandingPaths.has(pathname)) {
    const continueUrl = `${pathname}${search}`;
    target = `/login?continue=${encodeURIComponent(continueUrl)}`;
  }
  return target;
}

export function buildLoginRedirectForCurrentLocation(): string {
  let target = '/login';
  if (typeof window !== 'undefined') {
    target = buildLoginRedirect(window.location.pathname, window.location.search);
  }
  return target;
}
